
import { LevelFeaturesSection } from "./LevelFeaturesSection";

interface LevelFeaturesTabProps {
  levelId: string;
}

export const LevelFeaturesTab = ({ levelId }: LevelFeaturesTabProps) => {
  return (
    <div className="p-3 h-full overflow-auto">
      <LevelFeaturesSection levelId={levelId} />
    </div>
  );
};
